import { Box, Button, Menu, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { SortIcon } from '../shared/CustomIcons.styled';

const PriceMenu = ({ sortByPrice }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [type, setType] = useState('default');
  // const [type, setType] = useState(null);
  const sortHandsetByPrice = sorttype => {
    sortByPrice(sorttype);

    // if (sorttype === 'default') setType('Default');
    // else if (sorttype === 'lth') setType('Low to High');
    // else if (sorttype === 'htl') setType('High to Low');
    setAnchorEl(null);
    setType(sorttype);
  };
  const handleClick = e => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  let label;
  if (type === 'lth') {
    label = 'Low to High';
  } else if (type === 'htl') {
    label = 'High to Low';
  } else {
    label = 'Default';
  }

  return (
    <Box>
      <Button
        variant='buttonSmall'
        id='basic-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        aria-label={`Price, ${label}`}
        sx={{
          textTransform: 'capitalize',
          alignItems: 'center',
          justifyContent: 'space-between',
          float: 'right',
          color: theme.palette.secondary.mobileActiveToggleBackground,
          padding: '0px 16px',
          minHeight: 0,
          height: 0,
          lineHeight: '0px',
          minWidth: 16,

          '&:focus-visible': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 8,
            borderRadius: 4,
          },
        }}
      >
        {/* Price {type ? `[${type}]` : ''} */}
        Price
        <SortIcon
          sx={{
            fontSize: '.6rem',
            ml: 0.5,
            color: theme.palette.primary.buttonColor,
          }}
        />
      </Button>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{ color: theme.palette.secondary.mobileActiveToggleBackground }}
      >
        <MenuItem
          onClick={() => sortHandsetByPrice('default')}
          role='menuitemradio'
          aria-checked={type === 'default'}
          aria-label='Default'
        >
          Default
        </MenuItem>
        <MenuItem
          onClick={() => sortHandsetByPrice('lth')}
          role='menuitemradio'
          aria-checked={type === 'lth'}
          aria-label='Low to High'
        >
          Low to High
        </MenuItem>
        <MenuItem
          onClick={() => sortHandsetByPrice('htl')}
          role='menuitemradio'
          aria-checked={type === 'htl'}
          aria-label='High to Low'
        >
          High to Low
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default PriceMenu;
